import { LOCALE } from 'constants/locale'

const formatDate = (value: string) => {
  return Intl.DateTimeFormat(LOCALE, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(value))
}

export default formatDate
